import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'employee/'

const initialState = {
    employeeList: [],
    employeeListReport: [],
    indEmployee: [],
    allowancesSliceData: [],
    empForList: [],
    empListForAtt: [],
    isLoading: false,
    isLoadingEmpAll: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getEmployeeList = createAsyncThunk('emp/gel', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getEmployeeList')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getEmployeeListReport = createAsyncThunk('emp/gelr', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getEmployeeListReport')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getEmployeeForList = createAsyncThunk('emp/gfl', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getEmployeeForList')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addNewEmployee = createAsyncThunk('emp/ane', async (empData, thunkAPI) => {
    try {
        const form = new FormData()

        form.append('data', JSON.stringify(empData.payload));

        if (empData.empImageFile) form.append('image', empData.empImageFile)

        const result = await axios.post(API_URL + 'addNewEmployee', form)

        console.log("Result in slice:", result)

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateEmployee = createAsyncThunk('emp/ue', async (empData, thunkAPI) => {
    try {
        const form = new FormData()

        form.append('data', JSON.stringify(empData.payload));

        if (empData.empImageFile) form.append('image', empData.empImageFile)

        const result = await axios.post(API_URL + 'updateEmployee', form)

        console.log("Result in slice:", result)

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getIndividualEomployees = createAsyncThunk('emp/gie', async (empID, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + '/getEmployeeList/' + empID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addEmpAllowances = createAsyncThunk('emp/aeallowance', async (empID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'allowance', empID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getEmpWiseAllowances = createAsyncThunk('emp/gewallowance', async (empID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getEmpWiseAllowances', empID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleEmpAllowances = createAsyncThunk('emp/gswallowance', async (empID, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'allowance/' + empID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const editEmpAllowances = createAsyncThunk('emp/eeallowance', async (empID, thunkAPI) => {
    console.log(empID)
    try {
        const result = await axios.put(`${API_URL}allowance/${empID.empallowanceID}`, empID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteEmpAllowances = createAsyncThunk('emp/deallowance', async (empID, thunkAPI) => {

    try {
        const result = await axios.delete(`${API_URL}allowance/${empID}`, empID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getEmpListForAttendance = createAsyncThunk('emp/gelfa', async (_, thunkAPI) => {

    try {
        const result = await axios.get(`${API_URL}getEmpListForAttendance`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const menuSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.employeeList = []
            state.employeeListReport = []
            state.indEmployee = []
            state.allowancesSliceData = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmployeeList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getEmployeeList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.employeeList = action.payload
            })
            .addCase(getEmployeeList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.employeeList = []
            })
            .addCase(getIndividualEomployees.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getIndividualEomployees.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.indEmployee = action.payload
            })
            .addCase(getIndividualEomployees.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.indEmployee = []
            })
            .addCase(getEmployeeListReport.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getEmployeeListReport.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.employeeListReport = action.payload
            })
            .addCase(getEmployeeListReport.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.employeeListReport = []
            })
            .addCase(getEmpWiseAllowances.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getEmpWiseAllowances.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.allowancesSliceData = action.payload
            })
            .addCase(getEmpWiseAllowances.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.allowancesSliceData = []
            })
            .addCase(getEmpListForAttendance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getEmpListForAttendance.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.empListForAtt = action.payload
            })
            .addCase(getEmpListForAttendance.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.empListForAtt = []
            })
            .addCase(addEmpAllowances.pending, (state) => {
                state.isLoadingEmpAll = true
            })
            .addCase(editEmpAllowances.pending, (state) => {
                state.isLoadingEmpAll = true
            })
            .addCase(deleteEmpAllowances.pending, (state) => {
                state.isLoadingEmpAll = true
            })
            .addCase(addEmpAllowances.fulfilled, (state) => {
                state.isLoadingEmpAll = false
            })
            .addCase(editEmpAllowances.fulfilled, (state) => {
                state.isLoadingEmpAll = false
            })
            .addCase(deleteEmpAllowances.fulfilled, (state) => {
                state.isLoadingEmpAll = false
            })
            .addCase(getEmployeeForList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getEmployeeForList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.empForList = action.payload
            })
            .addCase(getEmployeeForList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.empForList = []
            })
    }
})

export const { reset } = menuSlice.actions

export default menuSlice.reducer